export const prepareOptions = (maxQuantity: number): number[] => {
  const options = [];

  for (let option = 1; option <= maxQuantity; option++) {
    options.push(option);
  }

  return options;
};
